import { DateTime } from 'luxon';

export default function(value) {
  if (!value) return '';
  return DateTime.fromISO(value).toLocaleString(DateTime.TIME_SIMPLE);
}
